import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "../../lib/cn";
export const Card = ({ className, ...props }) => (_jsx("div", { className: cn("rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm sm:p-5", className), ...props }));
export const CardTitle = ({ className, ...props }) => (_jsx("h2", { className: cn("text-lg font-semibold tracking-tight text-foreground sm:text-xl", className), ...props }));
